import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ContactImage } from '../Common/Icons';

export const UserImage = (props) => {
  const { url, name } = props;
  // Track which URL has fully loaded so isLoaded resets immediately when url changes
  const [loadedUrl, setLoadedUrl] = useState(null);
  const isLoaded = loadedUrl === url && url != null;
  const onLoad = () => setLoadedUrl(url);
  const onError = () => setLoadedUrl(null);
  return (
    <div className="user-image-container" title={name}>
      {url && (
        <img
          onLoad={onLoad}
          onError={onError}
          className={!isLoaded ? 'user-image user-image-hide' : 'user-image'}
          src={url}
          alt="avatar"
        />
      )}
      {!isLoaded && <ContactImage className="user-profile-pic" />}
    </div>
  );
};

UserImage.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string,
};
